"use client";

import Image from "next/image";

export const MissionVisionSection = () => {
  return (
    <div id="mission" className="relative z-10 flex items-center justify-center px-4 md:px-16 lg:px-32 pb-32 bg-[#212121]">
      <div className="w-full max-w-[1280px]">
        {/* Mission + Vision */}
        <div className="relative flex flex-col md:flex-row gap-8 items-center justify-end h-auto md:h-[600px]">
          {/* Graph */}
          <div className="relative flex-1 w-full md:w-auto shrink-0 md:shrink">
            <div className="relative w-full md:w-[341px] lg:w-auto h-[266px] lg:h-[420px]">
              <Image
                src="/images/graph.webp"
                alt="Growth graph"
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 341px, 600px"
                className="object-contain"
              />
            </div>
          </div>

          {/* Mission + Vision bullets */}
          <div className="relative flex flex-1 flex-col gap-8 w-full">
            {/* Mission */}
            <div className="flex flex-col gap-6 py-6 overflow-hidden h-[134px]">
              <div className="flex flex-col items-start">
                <span className="inline-block text-[14px] font-medium bg-white text-[#383a41] px-2 py-1.5 rounded tracking-[0.14px] leading-[18px]">
                  Mission
                </span>
              </div>
              <p className="text-[20px] text-[#f8f7f4] leading-7 tracking-[-0.04px]">
                To build the reliable tools that power merchant growth.
              </p>
            </div>

            {/* Vision */}
            <div className="flex flex-col gap-6 py-6 overflow-hidden h-[134px]">
              <div className="flex flex-col items-start">
                <span className="inline-block text-[14px] font-medium bg-white text-[#383a41] px-2 py-1.5 rounded tracking-[0.14px] leading-[18px]">
                  Vision
                </span>
              </div>
              <p className="text-[20px] text-[#f8f7f4] leading-7 tracking-[-0.04px]">
                To be the foundation on which the best Shopify brands are built.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
